import React from 'react';
// import '../Footer.css';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';
import useMeasure from 'react-use-measure';
import ScreenWidthListener from '../../General/ScreenWidthListener';
import CloseIcon from '../../../assets/images/close_btn.png';

const promotionicon = `${process.env.REACT_APP_CP_MEDIA_DOMAIN}/img/icon-promotion_promotion.png`;
const icontop = `${process.env.REACT_APP_CP_MEDIA_DOMAIN}/img/icon-top.png`;

const Imgdiv = styled.div`
  position: absolute;
  left: 10px;
  top: -23px;
`;

const PromoImg = styled.img`
  width: 45px;
  height: 60px;
`;

const Button = styled.button`
  position: absolute;
  background-color: #444;
  border-radius: 50px;
  padding: 5px;
  left: 89%;
  top: 7px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-color: transparent;

  &:focus {
    outline: none;
  }

  @media (max-width: 580px) {
    display: none;
  }
`;

const ArrowImg = styled.img`
  width: 10px;
  height: 10px;
  transform: ${({ Menu }) => (Menu ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: all 0.1s ease-in-out;
`;

const Flicker = keyframes`
0%   { opacity:1; }
25%  { opacity:0; }
50%  { opacity:1; }
75%  { opacity:0; }
100% { opacity:1; }
`;

const TextDiv = styled.div`
  white-space: nowrap;
  margin-right: 40px;
  padding-left: 60px;
  margin-top: 8px;

  -webkit-animation: ${Flicker} 1.5s;
  -moz-animation: ${Flicker} 1.5s;
  -o-animation: ${Flicker} 1.5s;
  animation: ${Flicker} 1.5s;
`;

const ContentText = styled.span`
  white-space: break-spaces;
  margin-bottom: 0px;
`;

const DropDownMenu = styled.div`
  background: #ffe794;
  position: absolute;
  top: 40px;
  padding: 15px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  color: #000;
  font-size: 13.2px;
  max-width: 360px;
  width: 100%;

  @media (max-width: 580px) {
    top: 40px;
    max-width: 100%;
  }
`;

const MenuTitle = styled.span`
  color: #444;
  text-transform: uppercase;
  font-size: 16px;
`;

const MenuTextDiv = styled.div`
  margin-top: 30px;
`;

const ClickText = styled.span`
  text-decoration-line: underline;
`;

const ClickA = styled.a`
  color: #000;
  &:hover {
    color: #000;
    text-decoration-line: none;
  }
`;

const Notification = styled.div``;

const TitleRow = styled.div`
  cursor: pointer;
`;

const ContentTitlte = styled.p`
  //font-weight: bolder;
  font-size: 13.2px;
  line-height: 1.5;
  white-space: break-spaces;
  margin: 0;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0px;
  top: 3px;
  z-index: 999;
  background-color: transparent;
  border: none;

  &:focus {
    outline: none;
  }

  img {
    width: 30px;
    height: 30px;
  }

  @media (max-width: 580px) {
    right: 0px;
    top: -2px;

    img {
      width: 40px;
      height: 40px;
    }
  }
`;

function NotificationBar(props) {
  const { t, i18n } = useTranslation();
  const { outerWidth } = ScreenWidthListener();
  const [Menu, setMenu] = React.useState(true);
  const { shownotification = false, announcement = {}, isScrollToFooter, setManualShowBar } = props;

  const [notiBarRef, { height: notiBarHeight }] = useMeasure();

  const openMuen = () => {
    setMenu(!Menu);
  };

  return (
    <>
      {shownotification === true && (
        <Notification
          id="notification"
          style={{
            transform: Menu ? `translateY(-${notiBarHeight.toFixed(1)}px)` : 'translateY(0px)',
            position: isScrollToFooter ? 'absolute' : 'fixed',
            bottom: isScrollToFooter ? '' : '0px',
            marginTop:
              !isScrollToFooter || (isScrollToFooter && outerWidth > 580) ? '-50px' : '-35px',
          }}
        >
          <CloseButton type="button" onClick={() => setManualShowBar(false)}>
            <img src={CloseIcon} alt="" />
          </CloseButton>

          <TitleRow onClick={openMuen}>
            <Imgdiv>
              <PromoImg src={promotionicon} />
            </Imgdiv>
            {/* <Button id="promobutton">
              <ArrowImg src={icontop} Menu={Menu} />
            </Button> */}
            <TextDiv>
              <MenuTitle>
                {i18n.language === 'en' ? announcement.title : announcement.chineseTitle}
              </MenuTitle>
            </TextDiv>
          </TitleRow>

          {Menu && (
            <ClickA
              href={i18n.language === 'en' ? announcement.urlLink : announcement.chineseUrlLink}
              target="_blank"
            >
              <DropDownMenu ref={notiBarRef}>
                <ContentTitlte
                  dangerouslySetInnerHTML={{
                    __html:
                      i18n.language === 'en' ? announcement.content : announcement.chineseContent,
                  }}
                />
                {/* <ContentText>{t('footer.promobarDetail1')}</ContentText> */}

                {/* <MenuTextDiv>
                  <ClickText>
                    <span style={{ textDecoration: 'underline' }}>
                      {` ${t('footer.promobarDetail2')} `}
                    </span>
                  </ClickText>
                  <ContentText style={{ textDecoration: 'underline' }}>
                    {t('footer.promobarDetail3')}
                  </ContentText>
                </MenuTextDiv> */}
              </DropDownMenu>
            </ClickA>
          )}
        </Notification>
      )}
    </>
  );
}

export default NotificationBar;
